import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_31712_605",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				transform: "matrix(-1 0 0 1 20 0)",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_31712_605)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.5894 2.04398C11.6909 2.00028 11.8024 1.98882 11.9101 2.01106C12.0177 2.0333 12.1167 2.08823 12.1946 2.16898L18.8371 7.61898C18.8887 7.67277 18.9297 7.73667 18.9576 7.80703C18.9856 7.87738 19 7.95281 19 8.02898C19 8.10516 18.9856 8.18058 18.9576 8.25094C18.9297 8.32129 18.8887 8.3852 18.8371 8.43898L12.1946 13.86C12.1434 13.9141 12.0824 13.9571 12.0152 13.9865C11.9479 14.0158 11.8758 14.031 11.8029 14.031C11.7297 14.0305 11.6573 14.0156 11.5894 13.987C11.4891 13.9425 11.4039 13.8677 11.3447 13.7721C11.2854 13.6766 11.255 13.5648 11.2571 13.451V10.205C4.15122 10.205 1.04686 12.297 1.51989 18.96C-1.48871 8.29898 4.28719 5.88898 11.2581 5.88898V2.57898C11.2559 2.46546 11.2863 2.35386 11.3453 2.25851C11.4044 2.16317 11.4894 2.08846 11.5894 2.04398Z",
				fill: "#C1C9E0"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgRedo);
export default ForwardRef;
